
<template>
  <div>
    <NewPayment kind="envelope" envelope_type="cash" @close="$router.push({ name: 'OpenEnvelopes' })"></NewPayment>
  </div>
</template>

<script>

export default {
  name: 'NewCash',
  components: {
    NewPayment: () => import('@/_backoffice/_financial/components/order_payment/NewPayment.vue'),
  },
}
</script>
